import { AuthGuard } from '@shared-guards/auth.guard';
import { ParamGuard } from '@shared-guards/param.guard';
import { NavigationDataKey } from '@shared-libs/enums';
import { InternalComponent } from './internal.component';

export const internalRoutes = [
	{
		path: '',
		component: InternalComponent,
		children: [
			{
				path: '',
				redirectTo: 'start',
				pathMatch: 'full',
			},
			{
				path: 'start',
				loadChildren: (): Promise<any> =>
					import('./gui/pages/home-page/home.module').then((m) => m.HomePageModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'kalender',
				loadChildren: (): Promise<any> =>
					import('./gui/pages/calendar-page/calendar.page.module').then((m) => m.CalendarPageModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'beego',
				loadChildren: (): Promise<any> =>
					import('./gui/pages/beego-page/beego.page.module').then((m) => m.BeegoPageModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'activiteiten',
				loadChildren: (): Promise<any> =>
					import('./gui/pages/events-list-page/events-list.module').then((m) => m.EventsListPageModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'beoordelingen',
				loadChildren: (): Promise<any> =>
					import('./gui/pages/ratings-page/ratings.module').then((m) => m.RatingsPageModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'uitleendienst',
				loadChildren: (): Promise<any> =>
					import('./gui/pages/devices-page/devices.module').then((m) => m.DevicesPageModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'wachtlijst',
				loadChildren: (): Promise<any> =>
					import('./gui/pages/wait-list-page/wait-list.module').then((m) => m.WaitListPageModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'clienten',
				loadChildren: (): Promise<any> =>
					import('./gui/pages/clients-page/clients.module').then((m) => m.ClientsPageModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'clienten/client',
				loadChildren: (): Promise<any> =>
					import('./gui/pages/client-page/client.module').then((m) => m.ClientPageModule),
				canActivate: [AuthGuard, ParamGuard],
				data: { navigationDataKey: [NavigationDataKey.client], redirect: '/internal/clienten' },
			},
			{
				path: 'clienten/samenvoegen',
				loadChildren: (): Promise<any> =>
					import('./gui/pages/merge-clients-page/merge-clients.module').then((m) => m.MergeClientsPageModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'clienten/importeren',
				loadChildren: (): Promise<any> =>
					import('./gui/pages/import-clients-page/import-clients.module').then(
						(m) => m.ImportClientsPageModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: 'medewerkers',
				loadChildren: (): Promise<any> =>
					import('./gui/pages/employees-page/employees.module').then((m) => m.EmployeesPageModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'medewerkers/medewerker',
				loadChildren: (): Promise<any> =>
					import('./gui/pages/employee-page/employee.module').then((m) => m.EmployeePageModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'administratie',
				loadChildren: (): Promise<any> =>
					import('./gui/pages/administration-page/administration.module').then(
						(m) => m.AdministrationPageModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: 'statistieken',
				loadChildren: (): Promise<any> =>
					import('./gui/pages/statistics-page/statistics.module').then((m) => m.StatisticsPageModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'hulpmiddelen',
				loadChildren: (): Promise<any> =>
					import('../shared/gui/pages/tools-page/tools.module').then((m) => m.ToolsPageModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'digibank',
				loadChildren: (): Promise<any> =>
					import('./gui/pages/tenant-page.ts/tenant.module').then((m) => m.TenantPageModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'digibank/template',
				loadChildren: (): Promise<any> =>
					import('./gui/pages/communication-template-page/communication-template.module').then(
						(m) => m.CommunicationTemplatePageModule
					),
				canActivate: [AuthGuard, ParamGuard],
				data: { navigationDataKey: [NavigationDataKey.templateVariables], redirect: '/internal/digibank' },
			},
			{
				path: 'digibank/permission',
				loadChildren: (): Promise<any> =>
					import('./gui/pages/permission-group-page/permission-group.module').then(
						(m) => m.PermissionGroupPageModule
					),
				canActivate: [AuthGuard, ParamGuard],
				data: { navigationDataKey: [NavigationDataKey.permissionsForm], redirect: '/internal/digibank' },
			},
			{ path: '**', redirectTo: 'login' },
		],
	},
];
